'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var experimentsSchema = Joi__default["default"].object().keys({
  'ex-dashboard-homepage': Joi__default["default"].boolean().description('Flag for determining whether the creator sees expermintal homepage'),
  'ex-experimentation-test-flag': Joi__default["default"].boolean().description('Flag for determining whether the exprimentation flag is on'),
  'ex-onboarding-v1': Joi__default["default"].boolean().description('Flag for determining whether the creator sees v1 onboarding flow'),
  'ex-onboarding-v2': Joi__default["default"].boolean().description('Flag for determining whether the creator sees v2 onboarding flow'),
  'ex-onboarding-v3': Joi__default["default"].boolean().description('Flag for determining whether the creator sees v3 onboarding flow')
}).required().description('LaunchyDarkly onboarding experiment flags');
var experimentsSchema$1 = experimentsSchema;

module.exports = experimentsSchema$1;
//# sourceMappingURL=experimentsSchema.model.js.map
